// コメント位置はPrettier対策
class AppCertification {
  //FIXME 本番設定に書き換えてください。
  /**
   * アプリケーションの定数値です。
   */
  APPVERSION = "26.07.01";
  APP_CONFIG = {
    //FIXME MockModeの有効無効
    // HttpClientのgetを対象として、dummy.jsonを読み込むフラグです。
    MOCK_MODE: false,

    /**
     * API接続用設定（VDI外アクセス）
     */
    // 本番環境
    BASE_URL: "https://cirrus-wh-ob.nikkon-is.com/",
  };

  /** datadog */
  DATADOG = {
    DD_APPLICATION_ID: "6deedcfd-957b-4a55-8290-75bf2e488003",
    DD_CLIENT_TOKEN: "pubc3bd4c278a3056da862f6584aa02778b",
    DD_SERVICE: "de-wh-ob-pc",
    DD_ENV: "de-wh-ob",
    DD_SESSION: 80,
  };
  /** datadog */
}

export const appCertification = new AppCertification();
